import { render, staticRenderFns } from "./SchemeOrdinance.vue?vue&type=template&id=d5fb3042&"
import script from "./SchemeOrdinance.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./SchemeOrdinance.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./SchemeOrdinance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports